export const SystemSS = ({ mediaItems, handleOpenModal, description }) => {
    return (
        <div className='my-8 w-full md:w-4/5 mx-auto'>
            <div
                className={`${
                    mediaItems.length === 2 ? 'flex-col md:w-1/2 md:flex-row justify-center mx-auto gap-2' : 'md:w-full'
                } flex justify-center w-full`}
            >
                {mediaItems.map((mediaItem, index) => (
                    <img
                        onClick={() => {
                            handleOpenModal('image', mediaItem.modalId, mediaItem.index)
                        }}
                        className='ss-thumb'
                        alt={`screenshot of game system ${mediaItem.modalId}-${mediaItem.index}`}
                        src={`${process.env.PUBLIC_URL}/images/ss/ss-${mediaItem.modalId}-${mediaItem.index}-s.webp`}
                    />
                ))}
            </div>

            {/* <div className=''>
                        <div className='mt-8 w-full md:w-4/5 mx-auto'>
                            <img
                                onClick={() => {
                                    handleOpenModal('image', 'protection', 1)
                                }}
                                className='ss-thumb max-w-full'
                                alt='gameflow button'
                                src={`${process.env.PUBLIC_URL}/images/ss/ss-protection-1-s.webp`}
                            />{' '}
                        </div>{' '} */}
            {description && (
                <p className='mt-4 text-pbnavy font-kiwi font-bold text-sub md:text-sm text-shadow-white text-center'>
                    {description}
                </p>
            )}
        </div>
    )
}
